module.exports = __webpack_public_path__ + "img/slide.0f7ebdac.jpg";